(() => {
  const theme = window.theme || {};
  const WISH_KEY = "gymbabe:wishlist";
  const SECTION_IDS = ["cart-drawer", "header"];

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) =>
    Array.from(root.querySelectorAll(sel));

  function money(cents) {
    const fmt = theme.moneyFormat || "€{{amount}}";
    const amount = (Number(cents) / 100).toFixed(2).replace(".", ",");

    return fmt
      .replace("{{amount}}", amount)
      .replace("{{amount_with_comma_separator}}", amount)
      .replace(
        "{{amount_no_decimals}}",
        String(Math.round(Number(cents) / 100))
      );
  }

  async function fetchJSON(url, options) {
    const res = await fetch(url, options);

    if (!res.ok) {
      throw new Error(theme.strings?.cartError || "Fout");
    }

    return res.json();
  }

  function jsRoute(route, fallback) {
    const url = route || fallback;
    return url.endsWith(".js") ? url : `${url}.js`;
  }

  async function refreshCartSections() {
    const params = new URLSearchParams({
      sections: SECTION_IDS.join(","),
    });

    const data = await fetchJSON(
      `${window.location.pathname}?${params.toString()}`
    );

    replaceSections(data);

    try {
      const cart = await fetchJSON("/cart.js");

      qsa("[data-cart-count]").forEach((el) => {
        el.textContent = String(cart.item_count);
        el.hidden = cart.item_count === 0;
      });

      const sub = qs("[data-cart-subtotal]");
      if (sub) sub.textContent = money(cart.total_price);

      const foot = qs("[data-cart-footer]");
      if (foot) foot.hidden = cart.item_count === 0;
    } catch {
      /* ignore */
    }
  }

  function replaceSections(sections) {
    if (!sections) return;

    Object.entries(sections).forEach(([id, html]) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      if (id.includes("cart-drawer") || id === "cart-drawer") {
        const next =
          doc.querySelector("[data-cart-drawer]") ||
          doc.body.firstElementChild;

        const cur = qs("[data-cart-drawer]");

        if (next && cur) {
          const open = cur.classList.contains("is-open");

          cur.replaceWith(next);

          if (open) {
            openCart();
          }
        }
      }

      const count = doc.querySelector("[data-cart-count]");

      if (count) {
        qsa("[data-cart-count]").forEach((el) => {
          el.textContent = count.textContent;
          el.hidden = count.textContent.trim() === "0";
        });
      }
    });
  }

  function openCart() {
    const drawer = qs("[data-cart-drawer]");

    if (!drawer || theme.cartDrawer === false) {
      window.location.href = theme.routes?.cart_url || "/cart";
      return;
    }

    drawer.hidden = false;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeCart() {
    const drawer = qs("[data-cart-drawer]");

    if (!drawer) return;

    drawer.hidden = true;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  async function addToCart(id, quantity = 1) {
    const body = new FormData();

    body.append("id", String(id));
    body.append("quantity", String(quantity));
    body.append("sections", SECTION_IDS.join(","));
    body.append("sections_url", window.location.pathname);

    const data = await fetchJSON(
      jsRoute(theme.routes.cart_add_url, "/cart/add"),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body,
      }
    );

    if (data.sections) {
      replaceSections(data.sections);
    } else {
      await refreshCartSections();
    }

    openCart();

    return data;
  }

  async function changeQty(key, quantity) {
    const body = new FormData();

    body.append("id", key);
    body.append("quantity", String(quantity));
    body.append("sections", SECTION_IDS.join(","));
    body.append("sections_url", window.location.pathname);

    const data = await fetchJSON(
      jsRoute(theme.routes.cart_change_url, "/cart/change"),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body,
      }
    );

    if (data.sections) {
      replaceSections(data.sections);
    } else {
      await refreshCartSections();
    }

    return data;
  }

  function getWish() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function setWish(list) {
    localStorage.setItem(WISH_KEY, JSON.stringify(list));
    syncWishUI();
  }

  function toggleWish(handle) {
    const list = getWish();
    const i = list.indexOf(handle);

    if (i >= 0) {
      list.splice(i, 1);
    } else {
      list.push(handle);
    }

    setWish(list);
  }

  function syncWishUI() {
    const list = getWish();

    qsa("[data-wish-handle]").forEach((btn) => {
      const on = list.includes(
        btn.getAttribute("data-wish-handle")
      );

      btn.classList.toggle("is-on", on);

      btn.setAttribute(
        "aria-label",
        on
          ? theme.strings.wishRemove
          : theme.strings.wishAdd
      );
    });

    qsa("[data-wish-count]").forEach((el) => {
      el.textContent = String(list.length);
      el.hidden = list.length === 0;
    });

    const page = qs("[data-wishlist-page]");

    if (page) {
      let shown = 0;

      qsa("[data-wish-item]", page).forEach((item) => {
        const handle = item.getAttribute("data-wish-item");
        const on = list.includes(handle);

        item.hidden = !on;

        if (on) shown += 1;
      });

      const empty = qs("[data-wishlist-empty]", page);
      const cta = qs("[data-wishlist-cta]", page);

      if (empty) empty.hidden = shown > 0;
      if (cta) cta.hidden = shown > 0;
    }
  }

  function parseDescription(root) {
    const raw = qs("[data-raw-description]", root);

    if (!raw) return;

    const strings = theme.strings || {};

    let text = raw.innerText
      .replace(/\u00a0/g, " ")
      .trim();

    text = text
      .replace(/\s*[✔✓]\s*/g, "\n• ")
      .replace(/\s+•\s+/g, "\n• ")
      .replace(
        /\s+(Kenmerken|Eigenschappen|Features|Prestatiedetails|Materiaal & pasvorm|Materiaal & fit|Materiaal|Pasvorm|Fit True to size|Pasvorm valt op maat|Specificaties|Details|Styling tip|Styling|Waarom jij deze set wilt hebben|Waarom GYMBABES[^.]*|GYMBABE GARANTIE|Garantie|Onderhoud)\s+/gi,
        "\n$1\n"
      );

    const lines = text
      .split(/\n+/)
      .map((l) => l.trim())
      .filter(Boolean);

    const headings = [
      {
        re: /^(kenmerken|eigenschappen|features|prestatiedetails)$/i,
        title: strings.features || "Kenmerken",
        bucket: "features",
      },
      {
        re: /^waarom\b/i,
        title: strings.features || "Kenmerken",
        bucket: "features",
      },
      {
        re: /^(materiaal.*|pasvorm.*|fit)$/i,
        title:
          strings.material ||
          "Materiaal & pasvorm",
        bucket: "material",
      },
      {
        re: /^(specificaties|details)$/i,
        title: "Details",
      },
      {
        re: /^styling/i,
        title: "Styling",
      },
      {
        re: /garantie/i,
        title: "Garantie",
      },
      {
        re: /^(onderhoud|care)$/i,
        title: "Onderhoud",
      },
    ];

    const intro = [];
    const features = [];
    const material = [];
    const extras = [];

    let bucket = "intro";
    let extra = null;

    const pushExtra = () => {
      if (
        extra &&
        (extra.paragraphs.length ||
          extra.bullets.length)
      ) {
        extras.push(extra);
      }

      extra = null;
    };

    for (const line of lines) {
      const heading = headings.find((h) =>
        h.re.test(
          line.replace(/[:：]\s*$/, "")
        )
      );

      if (heading) {
        pushExtra();

        if (heading.bucket === "features") {
          bucket = "features";
        } else if (
          heading.bucket === "material"
        ) {
          bucket = "material";
        } else {
          bucket = "extra";

          extra = {
            title: heading.title,
            paragraphs: [],
            bullets: [],
          };
        }

        continue;
      }

      const isBullet =
        /^([✔✓•●\-–]|\d+\.)\s+/.test(line);

      const value = isBullet
        ? line
            .replace(
              /^([✔✓•●\-–]|\d+\.)\s+/,
              ""
            )
            .trim()
        : line;

      if (bucket === "intro") {
        if (isBullet) {
          features.push(value);
        } else {
          intro.push(value);
        }
      } else if (bucket === "features") {
        features.push(value);
      } else if (bucket === "material") {
        material.push(value);
      } else if (extra) {
        if (isBullet) {
          extra.bullets.push(value);
        } else {
          extra.paragraphs.push(value);
        }
      }
    }

    pushExtra();

    const block = (
      title,
      paragraphs,
      bullets
    ) => {
      if (
        (!paragraphs ||
          !paragraphs.length) &&
        (!bullets ||
          !bullets.length)
      ) {
        return "";
      }

      return `
        <div class="copy-block">
          <h3>${title}</h3>

          ${(paragraphs || [])
            .map((p) => `<p>${p}</p>`)
            .join("")}

          ${
            bullets && bullets.length
              ? `<ul>${bullets
                  .map(
                    (b) =>
                      `<li>${b}</li>`
                  )
                  .join("")}</ul>`
              : ""
          }
        </div>
      `;
    };

    const html =
      block(
        strings.about ||
          "Over dit product",
        intro,
        []
      ) +
      block(
        strings.features || "Kenmerken",
        [],
        features
      ) +
      block(
        strings.material ||
          "Materiaal & pasvorm",
        [],
        material
      ) +
      extras
        .map((x) =>
          block(
            x.title,
            x.paragraphs,
            x.bullets
          )
        )
        .join("");

    if (html.trim()) {
      raw.outerHTML = html;
    }
  }

  function optionName(name) {
    const n = (name || "").toLowerCase();

    if (
      n === "kleur" ||
      n === "color" ||
      n === "colour"
    ) {
      return "color";
    }

    if (
      n === "maat" ||
      n === "size"
    ) {
      return "size";
    }

    return n;
  }

  function initProduct(root) {
    const form = qs(
      "[data-product-form]",
      root
    );

    if (!form) return;

    const jsonEl = qs(
      "[data-product-json]",
      form
    );

    if (!jsonEl) return;

    let product;

    try {
      product = JSON.parse(
        jsonEl.textContent
      );
    } catch {
      return;
    }

    const options = (
      product.options || []
    ).map((name, index) => ({
      name,
      type: optionName(name),
      index,
      value:
        (product.variants[0] &&
          product.variants[0]
            .options[index]) ||
        "",
    }));

    const currentId = qs(
      "[data-variant-id]",
      form
    );

    if (!currentId) return;

    const selected =
      product.variants.find(
        (v) =>
          String(v.id) ===
          currentId.value
      ) || product.variants[0];

    if (selected) {
      selected.options.forEach(
        (val, i) => {
          if (options[i]) {
            options[i].value = val;
          }
        }
      );
    }

    const findVariant = () =>
      product.variants.find((v) =>
        v.options.every(
          (val, i) =>
            !options[i] ||
            options[i].value === val
        )
      );

    const colorImages = {};

    const colorOpt = options.find(
      (o) => o.type === "color"
    );

    if (colorOpt) {
      product.variants.forEach((v) => {
        const c =
          v.options[colorOpt.index];

        const src =
          v.featured_image &&
          (v.featured_image.src ||
            v.featured_image);

        if (c && src) {
          if (!colorImages[c]) {
            colorImages[c] = [];
          }

          const url =
            typeof src === "string"
              ? src
              : src;

          if (
            !colorImages[c].includes(url)
          ) {
            colorImages[c].push(url);
          }
        }
      });
    }

    function render() {
      const variant = findVariant();

      const addBtn = qs(
        "[data-add]",
        form
      );

      const sticky = qs(
        "[data-sticky-add]"
      );

      const priceBox = qs(
        "[data-product-price]",
        root
      );

      const stickyPrice = qs(
        "[data-sticky-price]"
      );

      if (variant) {
        currentId.value = variant.id;

        const url = new URL(
          window.location.href
        );

        url.searchParams.set(
          "variant",
          variant.id
        );

        history.replaceState(
          {},
          "",
          url
        );

        if (addBtn) {
          addBtn.disabled =
            !variant.available;

          addBtn.textContent =
            variant.available
              ? theme.strings.add
              : theme.strings.soldOut;
        }

        if (sticky) {
          sticky.disabled =
            !variant.available;
        }

        if (priceBox) {
          const compare =
            variant.compare_at_price;

          priceBox.innerHTML =
            compare &&
            compare > variant.price
              ? `
                <div class="price">
                  <span class="price__compare">
                    ${money(compare)}
                  </span>

                  <span class="price__current">
                    ${money(variant.price)}
                  </span>
                </div>
              `
              : `
                <div class="price">
                  <span class="price__current">
                    ${money(variant.price)}
                  </span>
                </div>
              `;
        }

        if (stickyPrice) {
          stickyPrice.textContent =
            money(variant.price);
        }

        const img =
          variant.featured_image &&
          (variant.featured_image.src ||
            variant.featured_image);

        const main = qs(
          "[data-main-image]",
          root
        );

        if (img && main) {
          main.src = img.includes("?")
            ? img.replace(
                /width=\d+/,
                "width=1400"
              )
            : img;
        }
      } else if (addBtn) {
        addBtn.disabled = true;

        addBtn.textContent =
          theme.strings.unavailable;
      }

      const colorLabel = qs(
        "[data-color-label]",
        root
      );

      const sizeLabel = qs(
        "[data-size-label]",
        root
      );

      const color = options.find(
        (o) => o.type === "color"
      );

      const size = options.find(
        (o) => o.type === "size"
      );

      if (colorLabel && color) {
        colorLabel.textContent =
          color.value;
      }

      if (sizeLabel && size) {
        sizeLabel.textContent =
          size.value;
      }

      if (color) {
        qsa(
          "[data-thumb]",
          root
        ).forEach((thumb) => {
          const c =
            thumb.getAttribute(
              "data-color"
            );

          if (!c) return;

          thumb.hidden =
            c !== color.value;
        });

        const firstVisible = qsa(
          "[data-thumb]",
          root
        ).find((t) => !t.hidden);

        if (firstVisible) {
          qsa(
            "[data-thumb]",
            root
          ).forEach((t) =>
            t.classList.toggle(
              "is-active",
              t === firstVisible
            )
          );
        }
      }

      if (size) {
        qsa(
          ".size-btn",
          root
        ).forEach((btn) => {
          const value =
            btn.getAttribute(
              "data-value"
            );

          const probe =
            product.variants.find(
              (v) =>
                v.options.every(
                  (val, i) => {
                    if (
                      options[i]
                        .type ===
                      "size"
                    ) {
                      return (
                        val === value
                      );
                    }

                    return (
                      val ===
                      options[i].value
                    );
                  }
                )
            );

          btn.classList.toggle(
            "is-sold",
            !(probe &&
              probe.available)
          );

          const span =
            btn.querySelector("span");

          if (
            probe &&
            !probe.available
          ) {
            if (!span) {
              const s =
                document.createElement(
                  "span"
                );

              s.textContent =
                theme.strings.soldOut;

              btn.appendChild(s);
            }
          } else if (span) {
            span.remove();
          }
        });
      }
    }

    form.addEventListener(
      "click",
      (e) => {
        const btn =
          e.target.closest(
            "[data-option-btn]"
          );

        if (!btn) return;

        e.preventDefault();

        const index = Number(
          btn.getAttribute(
            "data-option-index"
          )
        );

        const value =
          btn.getAttribute(
            "data-value"
          );

        if (options[index]) {
          options[index].value =
            value;
        }

        qsa(
          `[data-option-btn][data-option-index="${index}"]`,
          form
        ).forEach((b) =>
          b.classList.toggle(
            "is-active",
            b === btn
          )
        );

        render();
      }
    );

    form.addEventListener(
      "submit",
      async (e) => {
        e.preventDefault();

        const id =
          currentId.value;

        const btn = qs(
          "[data-add]",
          form
        );

        if (btn) {
          btn.classList.add(
            "is-busy"
          );
        }

        try {
          await addToCart(id, 1);
        } catch (err) {
          alert(
            theme.strings
              .cartError ||
              err.message
          );
        } finally {
          if (btn) {
            btn.classList.remove(
              "is-busy"
            );
          }
        }
      }
    );

    const sticky = qs(
      "[data-sticky-add]"
    );

    if (sticky) {
      sticky.addEventListener(
        "click",
        () =>
          form.requestSubmit()
      );
    }

    qsa(
      "[data-thumb]",
      root
    ).forEach((thumb) => {
      thumb.addEventListener(
        "click",
        () => {
          const src =
            thumb.getAttribute(
              "data-src"
            );

          const main = qs(
            "[data-main-image]",
            root
          );

          if (src && main) {
            main.src = src;
          }

          qsa(
            "[data-thumb]",
            root
          ).forEach((t) =>
            t.classList.toggle(
              "is-active",
              t === thumb
            )
          );
        }
      );
    });

    parseDescription(root);
    render();
  }

  function bindUI() {
    document.addEventListener(
      "click",
      (e) => {
        if (
          e.target.closest(
            "[data-open-menu]"
          )
        ) {
          const d = qs(
            "[data-menu-drawer]"
          );

          if (d) {
            d.hidden = false;
          }
        }

        if (
          e.target.closest(
            "[data-close-menu]"
          )
        ) {
          const d = qs(
            "[data-menu-drawer]"
          );

          if (d) {
            d.hidden = true;
          }
        }

        if (
          e.target.closest(
            "[data-open-search]"
          )
        ) {
          const d = qs(
            "[data-search-dialog]"
          );

          if (d) {
            d.hidden = false;

            const input = qs(
              "input[type=search]",
              d
            );

            if (input) {
              input.focus();
            }
          }
        }

        if (
          e.target.closest(
            "[data-close-search]"
          )
        ) {
          const d = qs(
            "[data-search-dialog]"
          );

          if (d) {
            d.hidden = true;
          }
        }

        if (
          e.target.closest(
            "[data-cart-toggle]"
          )
        ) {
          if (
            theme.cartDrawer !==
            false
          ) {
            e.preventDefault();
            openCart();
          }
        }

        if (
          e.target.closest(
            "[data-close-cart]"
          )
        ) {
          closeCart();
        }

        if (
          e.target.closest(
            "[data-open-size-guide]"
          )
        ) {
          const m =
            qs("#SizeGuide");

          if (m) {
            m.hidden = false;
          }
        }

        if (
          e.target.closest(
            "[data-close-modal]"
          )
        ) {
          const m =
            e.target.closest(
              ".modal"
            ) ||
            qs("#SizeGuide");

          if (m) {
            m.hidden = true;
          }
        }

        const wish =
          e.target.closest(
            "[data-wish-handle]"
          );

        if (wish) {
          e.preventDefault();
          e.stopPropagation();

          toggleWish(
            wish.getAttribute(
              "data-wish-handle"
            )
          );
        }

        const qtyBtn =
          e.target.closest(
            "[data-qty-change]"
          );

        if (qtyBtn) {
          const item =
            qtyBtn.closest(
              "[data-key]"
            );

          if (!item) return;

          const key =
            item.getAttribute(
              "data-key"
            );

          const val =
            qtyBtn.getAttribute(
              "data-qty-change"
            );

          const current =
            Number(
              item.querySelector(
                ".qty__value"
              )?.textContent || 1
            );

          const next =
            val === "remove"
              ? 0
              : current +
                Number(val);

          changeQty(
            key,
            Math.max(0, next)
          ).catch((err) =>
            alert(err.message)
          );
        }

        const swatch =
          e.target.closest(
            "[data-swatch]"
          );

        if (swatch) {
          const card =
            swatch.closest(
              "[data-product-card]"
            );

          const img =
            card &&
            qs(
              "[data-card-image]",
              card
            );

          const src =
            swatch.getAttribute(
              "data-image"
            );

          if (img && src) {
            img.src = src;
          }

          qsa(
            "[data-swatch]",
            card
          ).forEach((s) =>
            s.classList.toggle(
              "is-active",
              s === swatch
            )
          );
        }
      }
    );

    qsa("[data-sort]").forEach(
      (select) => {
        select.addEventListener(
          "change",
          () => {
            const url =
              new URL(
                window.location.href
              );

            url.searchParams.set(
              "sort_by",
              select.value
            );

            window.location.href =
              url.toString();
          }
        );
      }
    );

    qsa(
      "[data-product-page]"
    ).forEach(initProduct);

    const related = qs(
      "[data-related-section]"
    );

    if (
      related &&
      related.dataset.url
    ) {
      fetch(related.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc =
            new DOMParser().parseFromString(
              html,
              "text/html"
            );

          const next =
            doc.querySelector(
              "[data-related-section]"
            );

          if (
            next &&
            next.querySelector(
              ".product-card"
            )
          ) {
            related.replaceWith(
              next
            );
          }
        })
        .catch(() => {});
    }

    syncWishUI();
  }

  document.addEventListener(
    "DOMContentLoaded",
    bindUI
  );
})();